var map = {
	"./rule-bg-ar.png": "c9b2",
	"./rule-bg-en.png": "bc12",
	"./rule-bg-in.png": "a179",
	"./rule-bg-ms.png": "83e8",
	"./rule-bg-zh.png": "71c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ce3";